import type { RouteRecordRaw } from "vue-router";

export const assistantRoutes: RouteRecordRaw[] = [
  // AI Assistants (public)
  // Static routes must come before dynamic :id
  {
    path: "/ai/assistants",
    name: "ai-assistant-index-public",
    component: () => import("./assistants/AssistantListPage.vue"),
  },
  {
    path: "/ai/assistants/:id",
    name: "ai_assistant-show",
    component: () => import("./assistants/AssistantDetailPage.vue"),
  },
];
